// Several events at once (a group whose pins can't be pulled apart by zooming: same venue, or zoomed right in):
// "N events here", soonest first (web/sheets.js resultsView).
import { distance } from "../../data/format";
import { T } from "../../shared/config";
import { RULES } from "../../shared/rules";
import { eventById } from "../../state/feed";
import { byStart } from "../../state/filtered";
import { closeSheet, moveMap, openSheet, useView } from "../../state/view";
import { CloseButton } from "../../ui/CloseButton";
import { EmojiBadge } from "../../ui/EmojiBadge";
import { TimeText } from "../../ui/TimeText";
import type { FeedEvent } from "../../data/event";
import styles from "./Results.module.css";

export function Results({ title, ids }: { title: string; ids: string[] }) {
  const loc = useView((s) => s.userLocation);
  const events = ids.map(eventById).filter((e): e is FeedEvent => !!e).sort(byStart);
  return (
    <div id="results">
      <div className={styles.head}><h3>{title}</h3><CloseButton onClick={closeSheet} /></div>
      {events.length ? events.map((e) => (
        <button type="button" key={e.id} className={styles.result} data-id={e.id}
          onClick={() => { moveMap({ lat: e.lat, lng: e.lng }, 15, true); openSheet({ kind: "event", id: e.id }); }}>
          <EmojiBadge event={e} />
          <span className={styles.text}>
            <div className={styles.t}>{e.title}</div>
            <TimeText event={e} as="div" className={styles.rel} />
            <div className={styles.meta}>{[e.venue_name, distance(e, loc), RULES.admission(e)].filter(Boolean).join(" · ")}</div>
          </span>
        </button>
      )) : <div className={styles.empty}><b>{T("list.noMatches")}</b>{T("list.noMatchesHint")}</div>}
    </div>
  );
}
